import React, {Component} from "react";

class Announcement extends Component{
    render(){
        return(
            <div className="breadcrumb-area">
                <h4>DragonKart</h4>
                <div className="announcement-card">
                    <div className="icon-card">
                        <i className="fas fa-link"></i>
                    </div>
                    <div className="announcement-text">
                        <p className="sec-txt bold-text">
                            You can open mystery boxes and claim $Kart tokens from here.
                        </p>
                    </div>
                </div>
            </div>
        )
    }
}

export default Announcement;